// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext } from "react";
import { EElectionEventLockedDown } from "@sequentech/ui-core";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
import { EMonitoringCapability } from "./types";
export var EMonitoringLock;
(function (EMonitoringLock) {
    EMonitoringLock["OPEN"] = "OPEN";
    EMonitoringLock["LOCKED_DOWN"] = "LOCKED_DOWN";
    /** The event has not loaded yet: nothing offers a change until it has. */
    EMonitoringLock["UNKNOWN"] = "UNKNOWN";
})(EMonitoringLock || (EMonitoringLock = {}));
/** The lock of an election event, or UNKNOWN while it is still loading. */
export function monitoringLock(event) {
    var _a;
    if (!event)
        return EMonitoringLock.UNKNOWN;
    return ((_a = event.presentation) === null || _a === void 0 ? void 0 : _a.locked_down) === EElectionEventLockedDown.LOCKED_DOWN
        ? EMonitoringLock.LOCKED_DOWN
        : EMonitoringLock.OPEN;
}
var capability = function (granted) {
    return granted ? EMonitoringCapability.GRANTED : EMonitoringCapability.DENIED;
};
export function useMonitoringPermissions(lock) {
    if (lock === void 0) { lock = EMonitoringLock.OPEN; }
    var auth = useContext(AuthContext);
    var has = function (permission) { return auth.isAuthorized(true, auth.tenantId, permission); };
    var view = has(IPermissions.MONITORING_VIEW);
    return {
        view: capability(view),
        configure: capability(view &&
            has(IPermissions.MONITORING_CONFIGURE) &&
            has(IPermissions.ELECTION_EVENT_WRITE) &&
            lock === EMonitoringLock.OPEN),
    };
}
